exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quizPage .stepProgressMeter{margin-bottom:2rem}.quizPage .pageHeader{margin-bottom:10px}.quizPage .pageHeader h1{font-size:1.4em}.quizPage .textVariety .textTitle{margin-top:0;margin-bottom:20px}.quizPage .closedQuiz{opacity:.4;pointer-events:none}.quizPage .curtainContainer{display:flex;justify-content:center}.quizPage .curtainContainer .curtain{width:60%;text-align:center;padding:15px}.quizPage .curtainContainer .curtain .lockImg{width:55px;margin-bottom:10px}.quizPage .textTitle{font-size:2rem;font-style:italic;text-align:center;max-width:54%;margin-left:23%}.quizPage .textTitle.onQuestionSelect{margin-top:0;margin-bottom:10px}.quizPage .warmupContainer{width:76%;margin-left:12%}.quizPage .warmupContainer .warmupQuestionsDisplay .changeQuestionLink{display:inline-block;font-size:.8em;cursor:pointer;margin-bottom:10px;padding-left:0;box-shadow:none!important}.quizPage .warmupContainer .warmupQuestionsDisplay .changeQuestionLink .glyphicon-refresh{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/quizzes/quiz_page.scss
// module id = 1532
// module chunks = 0